var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSymbol = function SvgSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 100 92"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#symbol_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00534A",
    d: "M100 23.45c-.172 9.008-4.675 36.275-46.681 66.932-1.03.686-2.107 1.056-3.324 1.056-1.078 0-2.14-.397-3.008-.9-11.811-8.617-20.673-16.959-27.273-24.663 15.907 2.332 30.618-11.371 30.618-11.371l20.818-20.18-7.018 9.339s1.818 8.76 2 9.495c.3 1.195.467 1.431 1.223 1.506a1.38 1.38 0 0 0 1.19-.477c.171-.203 2.67-2.536 2.67-2.536l1.753-19.086 2.134-2.102 3.758-3.672c2.129-2.129 2.767-4.933 1.426-6.273s-4.15-.702-6.273 1.426l-5.72 4.847c-.172.15-.338.3-.6.52-.097.07-18.76 0-18.76 0s-2.579 2.064-2.798 2.214c-.36.247-.596.665-.596 1.131 0 .756.22.95 1.373 1.373.713.262 9.238 2.98 9.238 2.98l8.642-5.157C32.581 63.098 7.967 49.271 7.967 49.271 1.389 37.374.129 28.228 0 23.67v-.22C0 10.498 11.634 0 25.981 0c10.905 0 20.24 6.064 24.083 14.642C53.946 6.102 63.157 0 74.008 0 88.355 0 99.99 10.498 100 23.45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "symbol_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v91.433H0z"
  })))));
};
export default SvgSymbol;